import { appUrls } from "../../EasyProjectsCommon/AppUrls";
import { ApiRequestAction } from "../../Redux/Actions";
import { api, ApiActionInfo } from "../../Redux/Actions/apiActions";
import { SuccessRequestAction } from "../../Redux/Middleware/apiMiddleware";

export interface ProjectData {
    EndDate: Date;
    ID: number;
}

export enum ActionTypes {
    GET_DURATION_START = "AI_FORECAST/GET_DURATION_START",
    GET_DURATION_SUCCESS = "AI_FORECAST/GET_DURATION_SUCCESS",
    GET_DURATION_FAILURE = "AI_FORECAST/GET_DURATION_FAILURE",
    FETCH_PROJECT_DATA_START = "AI_FORECAST/FETCH_PROJECT_DATA_START",
    FETCH_PROJECT_DATA_FAILURE = "AI_FORECAST/FETCH_PROJECT_DATA_FAILURE",
    SET_PROJECT_DATA = "AI_FORECAST/SET_PROJECT_DATA",
    CLOSE_DIALOG = "AI_FORECAST/CLOSE_DIALOG",
}

export const getDuration = (projectId: number): ApiActionInfo => {
    return {
        endpoint: appUrls.ml.getPredictionUrlForProject(projectId),
        body: {
            projectId,
        },
        types: {
            requestType: ActionTypes.GET_DURATION_START,
            successType: ActionTypes.GET_DURATION_SUCCESS,
            failureType: ActionTypes.GET_DURATION_FAILURE,
        },
        additionalParams: {
            postWithAuthToken: true,
        },
    };
};

export const getDurationApi = api.postJson<number>(getDuration);

export const getProjectData = (projectId: number): ApiActionInfo => {
    return {
        endpoint: appUrls.task.getAcChunk,
        body: {
            activityIds: [],
            projectIds: [projectId],
            customization: {
                columns: ["EndDate"],
                ReturnColumns: "RequestedOnly",
            },
        },
        types: {
            requestType: ActionTypes.FETCH_PROJECT_DATA_START,
            successType: ActionTypes.SET_PROJECT_DATA,
            failureType: ActionTypes.FETCH_PROJECT_DATA_FAILURE,
        },
        additionalParams: {
            postWithAuthToken: true,
        },
    };
};

export const getProjectDataApi = api.postJson<number>(getProjectData);

export type CloseDialog = ReturnType<typeof closeDialog>;
export const closeDialog = () =>
    ({
        type: ActionTypes.CLOSE_DIALOG,
    } as const);

export type AIForecastReducerAction =
    | SuccessRequestAction<ActionTypes.GET_DURATION_SUCCESS>
    | SuccessRequestAction<ActionTypes.SET_PROJECT_DATA>
    | ApiRequestAction<ActionTypes.GET_DURATION_START>
    | CloseDialog;
